var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-time-picker", {
    class: { require: _vm.getRequire && _vm.isNull() },
    attrs: {
      align: "right",
      size: "small",
      placeholder: "选择时间",
      format: _vm.format,
      editable: false,
      disabled: _vm.disabled,
      "value-format": "HH:mm:ss",
    },
    on: { change: _vm.change },
    model: {
      value: _vm.val,
      callback: function ($$v) {
        _vm.val = $$v
      },
      expression: "val",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }